import React from 'react';

import UserContainer from '../containers/user-container';

const Name = ({ name = '', email = '', pending, showPending }) => (
    <React.Fragment>
        { name || email }

        {
            showPending && pending ? ' (pending)' : null
        }
    </React.Fragment>
)

const UserName = ({ id, showPending }) => <UserContainer id={id}><Name showPending={showPending} /></UserContainer>;

export default UserName;
